import type {ReduxStore} from 'src/reducers';
import IndexStore from 'src/stores';

import * as React from 'react';
import {Provider} from 'react-redux';

import * as actions from 'src/actions/survey';
import {getAgencyConfig} from 'src/action-creators/agency';
import {getReleaseFlags} from 'src/action-creators/product-flags';

import FluxRoot from 'src/flux/root';
import SurveyNav from 'src/components/navigation/survey';
import Survey from 'src/components/survey/survey';
import ErrorBoundary from 'src/components/500/boundary';

import 'src/components/app.global.css';
import styles from 'src/components/app.css';

import css from './style.css';


export default function SurveyApp({
  sentEventId,
  reduxStore,
  senseStore,
}: {
  sentEventId: string;
  reduxStore: ReduxStore;
  senseStore: IndexStore;
}) {
  const params = React.useMemo(() => ({sentEventId}), [sentEventId]);

  return (
    // @ts-expect-error - TS2786 - 'Provider' cannot be used as a JSX component.
    <Provider store={reduxStore}>
      <FluxRoot store={senseStore}>
        <div className={styles.container}>
          <div className={styles.body}>
            <ErrorBoundary>
              {/* @ts-expect-error - TS2741 - Property 'store' is missing in type '{ children: Element; params: { sentEventId: string; }; }' but required in type 'Props'. */}
              <SurveyNav params={params}>
                <Survey params={params} />
              </SurveyNav>
            </ErrorBoundary>
          </div>
        </div>
      </FluxRoot>
    </Provider>
  );
}

export function dependencies({
  store,
  dispatch,
  params: {sentEventId},
}: any): any {
  return Promise.all([
    actions.getSentEvent(store, sentEventId),
    dispatch(getAgencyConfig()),
    dispatch(getReleaseFlags()),
  ]);
}
